var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClientBaseView',{attrs:{"title":"Integration Hub","sub-title":"Manage integrations with external products"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c(_vm.currentComponent,{tag:"component"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }